/**
 * Javascript file for the page with details on the current AI trainer. 
 * @author Adrian Rebmann, Eduardo Parducci
 */

import {
    getKITrainerByHash,
} from "../../../../api";
export default {
    name: "KITrainerDetail",
    props: ["hash"],

    /**
     * The vue instance's data object.
     * @property {boolea} loading - Information is currently being processed.
     * @property {object} trainer - The AI trainer object.
     */
    data() {
        return {
            loading: false,
            trainer: null
        };
    },

    /**
     * Expressions to watch.
     */
    watch: {
        $route: "fetchData"
    },

    /**
     * Called after the instance has been created.
     */
    created() {
        this.fetchData();
    },

    /**
     * The vue instance's method declaration.
     */
    methods: {
        /**
        * Shows a placeholder image in case there is an error concern the trainer's image.
        */ 
        imageLoadingError() {
            this.trainer.image = 'no-avatar.jpg'
        },

        /**
         * Returns to the previously visited page.
         */
        goBack() {
            this.$router.go(-1);
        },

        /**
         * Retrieves the AI trainer by the hash.
         */
        fetchData() {
            this.loading = true;
            getKITrainerByHash(this.hash).then(res => {
                console.log(res)
                this.trainer = res;
                this.loading = false;
            })

        }
    }
};



// WEBPACK FOOTER //
// ./src/components/search/kitrainersearch/detail/kitrainerdetail.js